var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4071 47.7432C24.617 45.6869 20.8725 44.2493 18.4788 44.2493C16.7831 44.2493 17.3775 44.9699 18.3275 46.1215C19.1904 47.1674 20.3466 48.569 20.3467 50.1092C20.3467 51.6497 19.1904 53.0515 18.3275 54.0976C17.3776 55.2492 16.7833 55.9697 18.4789 55.9697C20.8726 55.9697 24.6164 54.533 26.4072 52.4757C29.3707 55.0769 36.5752 57.1983 42.069 58.2503C41.9669 58.3764 41.8663 58.4984 41.7695 58.6158C40.8188 59.7689 40.2223 60.4923 41.9188 60.4923C43.4409 60.4923 45.5071 59.9075 47.273 58.9558C47.4647 58.9642 47.6443 58.9694 47.8073 58.9694C52.7004 58.9694 59.7578 55.003 59.7578 50.11C59.7578 45.2169 52.7004 41.2506 47.8073 41.2506C47.7836 41.2506 47.7566 41.2514 47.7301 41.2523C47.7144 41.2527 47.6989 41.2532 47.6843 41.2535C46.7772 39.0228 45.0407 36.2367 41.8826 35.5997C41.5625 35.5347 41.2306 35.6291 40.9913 35.8526C40.7528 36.0758 40.6365 36.4012 40.6803 36.7256C40.8441 37.9413 40.6909 39.9909 38.9295 42.6487C34.087 43.8117 28.8311 45.616 26.4071 47.7432ZM55.6328 48.8586C55.6328 49.6056 55.0277 50.2109 54.2806 50.2109C53.5334 50.2109 52.9282 49.6057 52.9282 48.8586C52.9282 48.1115 53.5334 47.5063 54.2806 47.5063C55.0276 47.5063 55.6328 48.1116 55.6328 48.8586Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0918 42.2261C63.0162 42.2261 63.7656 42.9754 63.7656 43.8998C63.7656 44.8249 63.0162 45.5744 62.0918 45.5744C61.1666 45.5744 60.4172 44.8249 60.4172 43.8998C60.4172 42.9754 61.1667 42.2261 62.0918 42.2261Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4794 36.946C59.1858 36.946 59.7578 37.518 59.7578 38.2244C59.7578 38.9308 59.1858 39.5028 58.4794 39.5028C57.7732 39.5028 57.2011 38.9308 57.2011 38.2244C57.2011 37.518 57.7732 36.946 58.4794 36.946Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8717 32.1804C59.6264 32.1804 58.6176 31.1715 58.6176 29.927C58.6176 28.6819 59.6265 27.6729 60.8717 27.6729C62.1161 27.6729 63.125 28.6819 63.125 29.927C63.125 31.1715 62.1161 32.1804 60.8717 32.1804Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3215 22.3919C56.6061 22.3919 56.0265 21.8123 56.0265 21.0962C56.0265 20.3808 56.6061 19.8013 57.3215 19.8013C58.0377 19.8013 58.6172 20.3808 58.6172 21.0962C58.6172 21.8123 58.0377 22.3919 57.3215 22.3919Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.960178755d1323d7e73f51bf73915d2c.svg";
export { ForwardRef as ReactComponent };